var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5322 0.760816L12.0576 0H9.18509V6.85231L9.1753 13.5455C9.1802 13.5952 9.18509 13.6499 9.18509 13.6997C9.18509 15.3754 7.84427 16.7429 6.19027 16.7429C4.53627 16.7429 3.19545 15.3804 3.19545 13.6997C3.19545 12.0239 4.53627 10.6564 6.19027 10.6564C6.53282 10.6564 6.86557 10.721 7.17386 10.8304V7.48881C6.85579 7.43411 6.52792 7.40428 6.19027 7.40428C2.77951 7.40925 0 10.2337 0 13.7046C0 17.1755 2.7795 20 6.19516 20C9.61082 20 12.3903 17.1755 12.3903 13.7046V5.74341C13.6284 7.00149 15.2286 8.22974 17 8.62257V5.20636C15.0769 4.34112 13.1635 1.78518 12.5322 0.760816Z",
    fill: "#EE2D2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.13b4d64e.svg";
export { ForwardRef as ReactComponent };